import { render, staticRenderFns } from "./BedroomScene.vue?vue&type=template&id=78287a04&scoped=true&lang=pug&"
import script from "./BedroomScene.vue?vue&type=script&lang=js&"
export * from "./BedroomScene.vue?vue&type=script&lang=js&"
import style0 from "./BedroomScene.vue?vue&type=style&index=0&id=78287a04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78287a04",
  null
  
)

export default component.exports